export default __webpack_public_path__ + "static/media/movie-search.0f37abde.png";